import { Layout } from 'components/atoms'
import { InputBuild, SelectBuild } from 'components/molecules'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormFinancingValue } from './form'
import { ViewFinancingFormProps } from './interfaces'

const ViewFinancingForm: React.FC = () => {
    const { register, watch } = useFormContext<{
        financing: ViewFinancingFormProps
    }>()

    return (
        <Layout
            full
            type="container"
            display="grid"
            gap={8}
            data-testid="form-container"
        >
            <Layout type="row" gutter={{ y: 1.5 }} data-testid="form-fields">
                {FormFinancingValue.map(({ layout, input, select }, key) => (
                    <Layout {...layout} key={key}>
                        {select ? (
                            <SelectBuild
                                {...select}
                                {...register(`financing.${select.id}`)}
                                value={
                                    watch(`financing.${select.id}`) as string
                                }
                                isDisable={true}
                            />
                        ) : (
                            input && (
                                <InputBuild
                                    {...input}
                                    {...register(`financing.${input.id}`, {
                                        valueAsNumber: input.type === 'number'
                                    })}
                                    value={
                                        watch(`financing.${input.id}`) as string
                                    }
                                    isDisable={true}
                                />
                            )
                        )}
                    </Layout>
                ))}
            </Layout>
        </Layout>
    )
}

export default ViewFinancingForm
